// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AppointmentsController from "./appointments_controller"
application.register("appointments", AppointmentsController)

import AutosubmitController from "./autosubmit_controller"
application.register("autosubmit", AutosubmitController)

import CookieBannerController from "./cookie_banner_controller"
application.register("cookie-banner", CookieBannerController)

import ExerciseAutocompleteController from "./exercise_autocomplete_controller"
application.register("exercise-autocomplete", ExerciseAutocompleteController)

import ExerciseBandAutocompleteController from "./exercise_band_autocomplete_controller"
application.register("exercise-band-autocomplete", ExerciseBandAutocompleteController)

import ExerciseSessionNestedFormController from "./exercise_session_nested_form_controller"
application.register("exercise-session-nested-form", ExerciseSessionNestedFormController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import MessageReadController from "./message_read_controller"
application.register("message-read", MessageReadController)

import MessagesModalsController from "./messages_modals_controller"
application.register("messages-modals", MessagesModalsController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import ParticipantStartTimeController from "./participant_start_time_controller"
application.register("participant-start-time", ParticipantStartTimeController)

import PasswordVisibilityController from "./password_visibility_controller"
application.register("password-visibility", PasswordVisibilityController)

import SetMeetingHostController from "./set_meeting_host_controller"
application.register("set-meeting-host", SetMeetingHostController)

import ToggleCollapseController from "./toggle_collapse_controller"
application.register("toggle-collapse", ToggleCollapseController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)

import ToggleExerciseNameController from "./toggle_exercise_name_controller"
application.register("toggle-exercise-name", ToggleExerciseNameController)
